module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightIt.45543ac6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-LightIt.ttf
// module id = 330
// module chunks = 3